module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back"
  }, [_c('div', {
    staticClass: "mine-box-title"
  }, [_vm._v("认证首页")]), _vm._v(" "), _c('div', {
    staticClass: "mine-content"
  }, [_c('div', {
    staticClass: "flex-between mine-li"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flex-start"
  }, [_c('div', {
    staticClass: "tishi"
  }, [_vm._v("完成后可获得单位相关业务权限")]), _vm._v(" "), (_vm.row.danwei.registstatus == 0) ? _c('el-link', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CertDanweiApply'
      }),
      expression: "{name:'CertDanweiApply'}"
    }],
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("去认证")]) : (_vm.row.danwei.registstatus == 3) ? _c('el-link', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CertDanweiResult'
      }),
      expression: "{name:'CertDanweiResult'}"
    }]
  }, [_vm._v("认证失败")]) : (_vm.row.danwei.registstatus == 1) ? _c('el-link', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CertDanweiResult'
      }),
      expression: "{name:'CertDanweiResult'}"
    }]
  }, [_vm._v("审核中")]) : (_vm.row.danwei.registstatus == 2) ? _c('el-link', {
    on: {
      "click": _vm.unbind
    }
  }, [_vm._v("解除认证")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bottom-button"
  }, [_c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'YundongyuanList'
      }),
      expression: "{name:'YundongyuanList'}"
    }],
    attrs: {
      "round": "",
      "type": "default"
    }
  }, [_vm._v("运动员管理")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CaipanList'
      }),
      expression: "{name:'CaipanList'}"
    }],
    attrs: {
      "round": "",
      "type": "default"
    }
  }, [_vm._v("随队裁判员")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'JiaolianList'
      }),
      expression: "{name:'JiaolianList'}"
    }],
    attrs: {
      "round": "",
      "type": "default"
    }
  }, [_vm._v("随队教练员")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-between mine-li"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "flex-start"
  }, [_c('div', {
    staticClass: "tishi"
  }, [_vm._v("关联实名信息，完成后可获得个人相关业务权限")]), _vm._v(" "), (_vm.row.cert.status == 0) ? _c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.toShimin
    }
  }, [_vm._v("去认证")]) : (_vm.row.cert.status == 1) ? _c('el-link', {
    on: {
      "click": _vm.unbindPerson
    }
  }, [_vm._v("解除认证")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.row.cert.status == 1) ? _c('div', {
    staticClass: "mt10"
  }, [_c('el-tag', {
    attrs: {
      "effect": "plain",
      "type": "success"
    }
  }, [_vm._v("已实名")]), _vm._v(" " + _vm._s(_vm.row.cert.user_name + ' ' + _vm.row.cert.user_code) + "\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.row.cert.status == 1) ? _c('div', {
    staticClass: "bottom-button"
  }, [_c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'UserSearchCaipan'
      }),
      expression: "{name:'UserSearchCaipan'}"
    }],
    attrs: {
      "round": "",
      "type": "default"
    }
  }, [_vm._v("裁判员查询")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'UserSearchJiaolian'
      }),
      expression: "{name:'UserSearchJiaolian'}"
    }],
    attrs: {
      "round": "",
      "type": "default"
    }
  }, [_vm._v("教练员查询")])], 1) : _c('div', [_c('div', {
    staticClass: "flex-start mt10"
  }, [_c('div', {
    staticClass: "mr10"
  }, [_vm._v("实名验证类型选择：")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.numTypeName),
      callback: function($$v) {
        _vm.numTypeName = $$v
      },
      expression: "numTypeName"
    }
  }, _vm._l((_vm.numTypeColumns), function(item) {
    return _c('el-radio', {
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-between mine-li"
  }, [_c('div', {
    staticClass: "flex-start"
  }, [_c('div', {
    staticClass: "info-row-title"
  }, [_vm._v("证件照管理 "), (_vm.row.photo.status == 2) ? _c('el-tag', {
    attrs: {
      "type": "success",
      "size": "small"
    }
  }, [_vm._v("审核成功")]) : _vm._e(), _vm._v(" "), (_vm.row.photo.status == 3) ? _c('el-tag', {
    attrs: {
      "type": "danger",
      "size": "small"
    }
  }, [_vm._v("审核失败")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-start"
  }, [_c('div', {
    staticClass: "tishi"
  }, [_vm._v("裁判员、教练员等证书照片显示")]), _vm._v(" "), _c('el-link', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CertPersonPhoto'
      }),
      expression: "{name:'CertPersonPhoto'}"
    }],
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("去管理")])], 1)])]), _vm._v(" "), (false) ? _c('van-cell-group', [(false) ? _c('van-cell', {
    attrs: {
      "title": "实名认证",
      "label": "上传身份证信息，完成后自动关联运动员、裁判员、教练员数据"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('div', {
          staticClass: "tiny-btn-1"
        }, [_vm._v("去认证")])]
      },
      proxy: true
    }], null, false, 2704647020)
  }) : _vm._e(), _vm._v(" "), (false) ? _c('van-cell', {
    attrs: {
      "title": "家长认证",
      "label": "上传身份证明信息，完成后自动关联子女运动员信息"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('div', {
          staticClass: "tiny-btn-1"
        }, [_vm._v("管理")])]
      },
      proxy: true
    }], null, false, 589936917)
  }) : _vm._e(), _vm._v(" "), (false) ? _c('van-cell', {
    attrs: {
      "title": "单位认证",
      "label": "关联CCA单位信息，完成后可获得单位相关业务权限"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [(_vm.row.danwei.registstatus == 0) ? _c('div', {
          directives: [{
            name: "rblink",
            rawName: "v-rblink",
            value: ({
              name: 'CertDanwei'
            }),
            expression: "{name:'CertDanwei'}"
          }],
          staticClass: "tiny-btn-1"
        }, [_vm._v("去认证")]) : (_vm.row.danwei.registstatus == 3) ? _c('div', {
          directives: [{
            name: "rblink",
            rawName: "v-rblink",
            value: ({
              name: 'CertDanweiResult'
            }),
            expression: "{name:'CertDanweiResult'}"
          }],
          staticClass: "tiny-btn-0"
        }, [_vm._v("认证失败")]) : (_vm.row.danwei.registstatus == 1) ? _c('div', {
          directives: [{
            name: "rblink",
            rawName: "v-rblink",
            value: ({
              name: 'CertDanweiResult'
            }),
            expression: "{name:'CertDanweiResult'}"
          }],
          staticClass: "tiny-btn-0"
        }, [_vm._v("审核中")]) : (_vm.row.danwei.registstatus == 2) ? _c('div', {
          staticClass: "tiny-btn-0",
          on: {
            "click": _vm.unbind
          }
        }, [_vm._v("解除认证")]) : _vm._e()]
      },
      proxy: true
    }], null, false, 4016103830)
  }) : _vm._e(), _vm._v(" "), (_vm.row.danwei.registstatus == 2) ? _c('van-cell', {
    attrs: {
      "value": _vm.row.danwei.name
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function() {
        return [_c('van-tag', {
          attrs: {
            "plain": "",
            "type": "success"
          }
        }, [_vm._v("已认证")])]
      },
      proxy: true
    }], null, false, 2624470635)
  }) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "bottom-button"
  }, [_c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'YundongyuanList'
      }),
      expression: "{name:'YundongyuanList'}"
    }],
    attrs: {
      "round": "",
      "type": "default"
    }
  }, [_vm._v("运动员管理")]), _vm._v(" "), _c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CaipanList'
      }),
      expression: "{name:'CaipanList'}"
    }],
    attrs: {
      "round": "",
      "type": "default"
    }
  }, [_vm._v("裁判员管理")]), _vm._v(" "), _c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'JiaolianList'
      }),
      expression: "{name:'JiaolianList'}"
    }],
    attrs: {
      "round": "",
      "type": "default"
    }
  }, [_vm._v("教练员管理")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-start"
  }, [_c('div', {
    staticClass: "info-row-title"
  }, [_vm._v("单位认证")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-start"
  }, [_c('div', {
    staticClass: "info-row-title"
  }, [_vm._v("实名认证")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-952e239a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/cert/CertIndex.vue
// module id = 1518
// module chunks = 0